exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-prod-box[data-v-bcaf4fdc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;text-align:center;font-size:.9rem;background-color:#ff5722;padding:4px 10px 4px 12px;border-radius:20px;height:28px;margin-left:12px}.lp-prod-box[data-v-bcaf4fdc]:first-child{margin:0}.lp-box-delete[data-v-bcaf4fdc]{font-size:12px;margin-left:6px}", ""]);

// exports
